














































import { APP_MODULE, DISABLED_SOCIAL } from '../../store/modules/app/constant'
import { Vue, Component, Watch } from 'vue-property-decorator'
import { Container, Logo, BackButton, Divider, NegativeSubheader } from '../atoms/'
import { SocialBox, SocialConfirmBox } from '../molecules'
import { LoginBox, RequireCreatePassword } from '../organisms'
import { EmailLoginPayload, SocialLoginPayload } from '../../store/api/type'
import {
  REGISTER_MODULE,
  APPLE_PROVIDER,
  LINE_PROVIDER,
  FACEBOOK_PROVIDER,
  DISPLAY_NAME,
  PROFILE_PICTURE_URL,
  EMAIL_PROVIDER,
  HAS_PASSWORD
} from '../../store/modules/register/constant'
import { required } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
import {
  AUTH_MODULE,
  REQUEST_SOCIAL_LOGIN,
  EMAIL_LOGIN,
  PASSWORD_SERVER_ERROR,
  RESET_PASSWORD_ERROR
} from '../../store/modules/auth/constant'
import translate from '@/language'

@Component({
  components: {
    Container,
    BackButton,
    Logo,
    SocialBox,
    SocialConfirmBox,
    LoginBox,
    Divider,
    NegativeSubheader,
    RequireCreatePassword
  },
  validations: {
    password: {
      required
    }
  },
  computed: {
    ...mapGetters(REGISTER_MODULE, [
      APPLE_PROVIDER,
      FACEBOOK_PROVIDER,
      LINE_PROVIDER,
      EMAIL_PROVIDER,
      PROFILE_PICTURE_URL,
      HAS_PASSWORD
    ]),
    ...mapGetters(AUTH_MODULE, [PASSWORD_SERVER_ERROR]),
    ...mapGetters(APP_MODULE, [DISABLED_SOCIAL])
  },
  methods: {
    ...mapActions(AUTH_MODULE, [REQUEST_SOCIAL_LOGIN, EMAIL_LOGIN, RESET_PASSWORD_ERROR])
  }
})
export default class EmailLogin extends Vue {
  private password?: string = ''

  @Watch('password')
  onPasswordChange() {
    this.$v.password.$touch()
    return (this as any)[RESET_PASSWORD_ERROR]()
  }

  mounted() {
    (this as any)[RESET_PASSWORD_ERROR]()
    this.$nextTick(() => {
      this.$v.$reset()
    })
    if (this.emailProvider == '') {
      this.$router.push('/login')
    }
  }

  get passwordError(): string {
    const { password } = this.$v
    if ((this as any)[PASSWORD_SERVER_ERROR]) {
      return (this as any)[PASSWORD_SERVER_ERROR]
    }
    if (password.$error) {
      if (!password.required) {
        return translate('', 'error-password-required')
      }
      if (!password.minLength) {
        return translate('', 'error-password-min-length')
      }
    }
    return ''
  }
  get passwaordCreated(): boolean {
    return (this as any)[HAS_PASSWORD]
  }
  get appleProvider(): string {
    return (this as any)[APPLE_PROVIDER]
  }
  get lineProvider(): string {
    return (this as any)[LINE_PROVIDER]
  }
  get facebookProvider(): string {
    return (this as any)[FACEBOOK_PROVIDER]
  }
  get emailProvider(): string {
    return (this as any)[EMAIL_PROVIDER]
  }
  get hasProviders(): boolean {
    return this.appleProvider !== '' || this.facebookProvider !== '' || this.lineProvider !== ''
  }
  get displayName(): string {
    return (this as any)[DISPLAY_NAME]
  }
  get profilePic(): string {
    return (this as any)[PROFILE_PICTURE_URL]
  }
  get error(): string {
    return this.$route?.query?.error as string
  }
  get isPasswordError(): boolean {
    return this.passwordError !== ''
  }
  get formError(): boolean {
    return this.$v.$invalid || this.isPasswordError
  }
  doLogin() {
    this.onPasswordChange()
    if (!this.formError) {
      const payload: EmailLoginPayload = {
        email: this.emailProvider,
        password: this.password as string,
        challenge: this.$route?.query?.challenge as string
      }
      return (this as any)[EMAIL_LOGIN](payload)
    }
  }
  async socialBinding(socialType: string) {
    const challenge = this.$route?.query?.challenge
    const payload: SocialLoginPayload = {
      provider: socialType,
      challenge: challenge as string,
      email: this.emailProvider,
      // eslint-disable-next-line @typescript-eslint/camelcase
      redirect_url: '',
      action: '',
      // eslint-disable-next-line @typescript-eslint/camelcase
      access_token: ''
    }
    return (this as any)[REQUEST_SOCIAL_LOGIN](payload)
  }
}
